<template>
  <header
    :class="appHeaderClass"
    class="app-header"
  >
    <div class="app-header-wrap container">
      <span class="app-header__logo">
        <logo-icon />
      </span>
      <ui-button
        class="app-header__button"
        theme="blue"
        @click="handleButtonClick"
      >
        Contact <span>Us</span>
      </ui-button>
    </div>
  </header>
</template>

<script>
import scrollTo from 'scroll-to'
import UiButton from './components/ui/UiButton'
import LogoIcon from 'static/assets/icons/LogoIcon.svg'

export default {
  name: 'AppHeader',
  components: {
    UiButton,
    LogoIcon,
  },
  data () {
    return {
      isPageScrolled: false,
    }
  },
  computed: {
    appHeaderClass () {
      return { 'app-header--scroll': this.isPageScrolled }
    },
  },
  methods: {
    handleButtonClick () {
      const contactUsSection = document.getElementById('contact-us-section')
      scrollTo(document.documentElement.scrolltop, contactUsSection.offsetTop - 30, {
        duration: 1000
      })
    },
  },
  mounted () {
    document.addEventListener('scroll', () => {
      this.isPageScrolled = window.pageYOffset > 0
    })
  },
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

.app-header
  border-bottom: 1px solid #dddddd
  position: relative
  z-index: 100
  background-color: #fff

  @include desktop
    border: none
    position: static
    z-index: 0

  &.app-header--scroll
    @include desktop
      z-index: 100 !important
      border-bottom: 1px solid #dddddd

.app-header-wrap
  display: flex
  justify-content: space-between
  align-items: center
  padding-left: 10px
  padding-right: 10px
  padding-top: 7px
  padding-bottom: 10px

  @include tablet
    padding: 12px 10px 17px

  @include desktop
    padding-top: 10px
    padding-right: 19px

.app-header__logo
  position: relative
  top: 5px

  @include tablet
    top: 7px
    padding-left: 8px

  svg
    width: 163px
    height: 24.28px
    fill: #1d3762

    @include tablet
      width: 258px
      height: 38.44px

.app-header__button
  /deep/
    button
      margin-right: 0
      margin-top: 3px
      padding: 7px 21px 9px

  @include tablet
    margin-top: 3px
    margin-right: 2px

    /deep/
      button
        padding-top: 7px
        padding-bottom: 9px
        margin-right: 3px

  span
    display: none

    @include tablet
      display: inline-block
</style>



// WEBPACK FOOTER //
// src/AppHeader.vue